export default (data) => (
  Array.isArray(data) ? (
    data
      .map(value => `${value.humanized_field} ${value.msg}`)
      .join(', ')
  ) : (
    'Some unexpected error occurred. Please try again.'
  )
)
